const SocketMessageReducers = (
  state = {
    show: false,
    message: "",
    rawMessage: false,
  },
  action
) => {
  switch (action.type) {
    case "SAVE_SOCKET_MESSAGE":
      return action.payload;
    case "CLEAR_SOCKET_MESSAGE":
      return { show: false, message: "", rawMessage: false };
    default:
      return state;
  }
};
export default SocketMessageReducers;
